"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/no-array-index-key */
const s = {
  Root: _styledComponents.default.div.withConfig({
    displayName: "TreeView__Root",
    componentId: "design-system__sc-1wicjdn-0"
  })(["display:block;"]),
  Title: _styledComponents.default.h3.withConfig({
    displayName: "TreeView__Title",
    componentId: "design-system__sc-1wicjdn-1"
  })(["font-family:\"Roboto Condensed\",Helvetica,Arial,sans-serif;color:#595959;font-size:20px;margin:0  0 26px 0;font-weight:500;"]),
  Tree: _styledComponents.default.ul.withConfig({
    displayName: "TreeView__Tree",
    componentId: "design-system__sc-1wicjdn-2"
  })(["position:relative;list-style:none;padding:0 20px;&:before{content:\"\";position:absolute;left:0;top:7px;width:1px;background-image:linear-gradient(to bottom,rgba(180,180,180,.5) 50%,#fff 0%);background-position:left;background-size:1px 10px;background-repeat:repeat-y;height:", ";}"], _ref => {
    let {
      lineHeight
    } = _ref;
    return lineHeight || 'calc(100% - 14px)';
  }),
  TreeItem: _styledComponents.default.li.withConfig({
    displayName: "TreeView__TreeItem",
    componentId: "design-system__sc-1wicjdn-3"
  })(["position:relative;margin-bottom:20px;& > *:first-child{margin:0;}&:before{content:\"\";position:absolute;background:#fff;left:-24px;top:7px;border:1.5px solid rgba(180,180,180,.5);border-radius:50%;width:6px;height:6px;}"])
};

const typeValidate = obj => {
  const isArray = Array.isArray(obj);
  if (!isArray) return false;
  if (obj.length === 0) return false;
  const checkItems = obj.filter(el => !el.item);
  const hasMissingItem = checkItems.length !== 0;
  return !hasMissingItem;
};

const TreeView = _ref2 => {
  let {
    title,
    dataOBJ,
    customMessage,
    lineHeight
  } = _ref2;

  const renderTree = obj => {
    const {
      item,
      child
    } = obj;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(s.TreeItem, null, item), child && /*#__PURE__*/_react.default.createElement(s.Tree, {
      lineHeight: lineHeight
    }, child.map((el, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, renderTree(el)))));
  };

  return /*#__PURE__*/_react.default.createElement(s.Root, null, /*#__PURE__*/_react.default.createElement(s.Title, null, title), typeValidate(dataOBJ) ? /*#__PURE__*/_react.default.createElement(s.Tree, {
    lineHeight: lineHeight
  }, dataOBJ.map((el, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: index
  }, renderTree(el)))) : /*#__PURE__*/_react.default.createElement("p", null, customMessage));
};

TreeView.propTypes = {
  title: _propTypes.default.string,
  customMessage: _propTypes.default.string,
  lineHeight: _propTypes.default.string,
  dataOBJ: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};
TreeView.defaultProps = {
  title: '',
  customMessage: 'Nothing to display',
  lineHeight: ''
};
var _default = TreeView;
exports.default = _default;